import debounce from 'lodash/debounce';

const $list = document.querySelector('[data-nav-list]');
if ($list) {
    const $items = $list.querySelectorAll('[data-nav-item]');
    $list.classList.add('-more');
    const buildMoreMenu = () => {
        // remove hiding, but also make items invisible until we're done
        $items.forEach(($item) => {
            $item.classList.remove('-hide', '-right');
            $item.style.opacity = 0;
        });

        // use a timeout to allow page to render
        setTimeout(() => {
            const firstTop = $items[0].getBoundingClientRect().top;
            const lastTop = $items[$items.length - 1].getBoundingClientRect().top;
            const $moreList = $list.querySelector('[data-nav-morelist]');
            // empty the list
            while ($moreList.firstChild) {
                $moreList.removeChild($moreList.firstChild);
            }

            if (firstTop !== lastTop) {
                let firstLine = true;
                $items.forEach(($item) => {
                    // check to see if the top offset is more than the first item
                    // console.log(firstTop);
                    // console.log([i, $item.offset().top]);
                    if ($item.getBoundingClientRect().top !== firstTop || firstLine === false) {
                        firstLine = false;
                        const $moreItem = $item.cloneNode(true);
                        // clean up the more sub items
                        $moreItem.querySelectorAll('ul').forEach((el) => {
                            el.parentNode.removeChild(el);
                        });
                        $moreItem.classList.remove('-level-1', '-hide');
                        $moreItem.classList.add('-level-2', '-sub');
                        $moreItem.querySelectorAll('a').forEach((el) => {
                            el.classList.remove('-level-1');
                            el.classList.add('-level-2', '-sub');
                        });
                        $moreItem.style.opacity = 1;
                        $moreList.appendChild($moreItem);
                        $item.classList.add('-hide');
                    }
                });
            }

            // add -right to the last un-hidden item
            // $items.filter(':not(.-hide)').last().addClass('-right');
            const $lastRight = $list.querySelector('[data-nav-item]:not(.-hide):last-child');
            if ($lastRight) {
                $lastRight.classList.add('-right');
            }
            // if we have moreItems, create the moreItems menu
            if ($moreList.hasChildNodes()) {
                $list.classList.add('-more');
            } else {
                $list.classList.remove('-more');
            }

            // make 'em visible again
            $items.forEach((el) => {
                el.style.opacity = 1;
            });
        }, 100);
    };

    buildMoreMenu();
    window.addEventListener('resize', debounce(buildMoreMenu, 500, { leading: true }));
}
